<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold">new interchange</small>
      </legend>
      <div>
        <div class="row">
          <div class="col-md-12">
            <fieldset class="border p-3">
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Customer name:</label>
                  <span style="font-size:13px;">{{Requisition.customer_name}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Cargo no:</label>
                  <span style="font-size:13px;">{{Requisition.container_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">T812 entry:</label>
                  <span style="font-size:13px;">{{Requisition.t812_entry}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Truck no:</label>
                  <span style="font-size:13px;">{{Requisition.truck_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Trailer no:</label>
                  <span style="font-size:13px;">{{Requisition.trailer_no}}</span>
                </div>
                <div class="col-md-4">
                  <label style="font-size:13px; font-weight: bold">Driver name:</label>
                  <span style="font-size:13px;">{{Requisition.driver_name}}</span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <p></p>
        <p></p>

        <form @submit.prevent="newInterchange()" enctype="multipart/form-data">
          <div class="row">
            <input type="hidden" class="requisition_id" :value="Requisition.id" />
            <input type="hidden" class="cargo_id" :value="Requisition.cargo_id" />
            <input type="hidden" class="truck_id" :value="Requisition.truck_id" />
            <div class="col-md-6">
              <div class="form-group">
                <label>Interchange nuomber</label>
                <input
                  type="number"
                  class="form-control interchange_no"
                  placeholder="interchange"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Interchange Document</label>
                <input
                  type="file"
                  class="form-control interchange_file"
                  placeholder="Interchange file"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat creatingInterchange btn-rounded">
            <i class="fa fa-plus"></i> Add Interchange
          </button>
          <button type="button" class="btn btn-primary btn-flat creatingInterchangeLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import $ from "jquery";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Requisition.length === 0) {
      router.push("/managerequisitions");
    }
  },

  computed: {
    ...mapGetters(["Requisition"])
  },

  methods: {
    ...mapActions(["newInterchange"])
  }
};
</script>
<style scoped>
.creatingInterchangeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/interchanges/interchange.vue